import * as tslib_1 from "tslib";
import { PerspectiveProjection } from "@awayjs/core";
import { ImageCube, SingleCubeTexture } from "@awayjs/graphics";
import { ShadowMapperBase } from "./ShadowMapperBase";
var CubeMapShadowMapper = (function (_super) {
    tslib_1.__extends(CubeMapShadowMapper, _super);
    function CubeMapShadowMapper() {
        var _this = _super.call(this) || this;
        _this._depthMapSize = 512;
        _this._needsRender = new Array();
        _this.initCameras();
        return _this;
    }
    CubeMapShadowMapper.prototype.initCameras = function () {
        this._depthProjections = new Array();
        // posX, negX, posY, negY, posZ, negZ
        this.addProjection(0, 90, 0);
        this.addProjection(0, -90, 0);
        this.addProjection(-90, 0, 0);
        this.addProjection(90, 0, 0);
        this.addProjection(0, 0, 0);
        this.addProjection(0, 180, 0);
    };
    CubeMapShadowMapper.prototype.addProjection = function (rotationX, rotationY, rotationZ) {
        var projection = new PerspectiveProjection();
        projection.transform.rotateTo(rotationX, rotationY, rotationZ);
        projection.near = .01;
        projection.fieldOfView = 90;
        this._depthProjections.push(projection);
    };
    /**
     *
     * @returns {SingleCubeTexture}
     * @private
     */
    CubeMapShadowMapper.prototype._createDepthTexture = function () {
        return new SingleCubeTexture(new ImageCube(this._depthMapSize));
    };
    /**
     *
     * @param projection
     * @private
     */
    CubeMapShadowMapper.prototype._updateDepthProjection = function (projection) {
        var light = (this._light);
        var maxDistance = light._pFallOff;
        var pos = this._light.scenePosition;
        // todo: faces outside frustum which are pointing away from camera need not be rendered!
        for (var i = 0; i < 6; ++i) {
            this._depthProjections[i].far = maxDistance;
            this._depthProjections[i].transform.moveTo(pos.x, pos.y, pos.z);
            this._needsRender[i] = true;
        }
    };
    /**
     *
     * @param view
     * @param target
     * @param renderer
     * @private
     */
    CubeMapShadowMapper.prototype._drawDepthMap = function (view, target, renderer) {
        for (var i = 0; i < 6; ++i)
            if (this._needsRender[i])
                renderer._iRender(this._depthProjections[i], view, target.imageCube, null, i);
    };
    return CubeMapShadowMapper;
}(ShadowMapperBase));
export { CubeMapShadowMapper };



// WEBPACK FOOTER //
// ../dist/lib/shadowmappers/CubeMapShadowMapper.js